<section class="cluster" [attr.aria-labelledby]="titleId">
  <hr class="divider" aria-hidden="true" />
  <h2 [id]="titleId" class="cluster-title">{{ title }}</h2>
  @if (helperText) {
    <p class="cluster-helper">{{ helperText }}</p>
  }
  <div class="cluster-fields">
    <ng-content></ng-content>
  </div>
</section>
